import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {
  matchesApi,
  sponsersApi,
  sportEarlySalesApi,
  sportticketsApi,
} from 'src/app/shared/constants/api.constants';
import { IMatch } from 'src/app/shared/models/IMatch.model';
import { IMatchTicket } from 'src/app/shared/models/match-ticket.model';
import { ITeamSponsor } from 'src/app/shared/models/teamSponsor.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ChooseYourTeamDialogComponent } from '../../components/choose-your-team-dialog/choose-your-team-dialog.component';
import { Subscription } from 'rxjs';
import { forkJoin } from 'rxjs';
import { ToastService, HelpersService, HttpBaseService } from '@evento-ng/libs';
import { Toast } from 'src/app/shared/enums/toast';
import { ACCESS_TOKEN } from 'src/app/shared/constants/general.constants';
import { LoginPopupComponent } from 'src/app/shared/components/login-popup/login-popup.component';
import { MatchStatusEnum } from 'src/app/shared/enums/match-status.enum';
@Component({
  selector: 'app-match-details',
  templateUrl: './match-details.component.html',
  styleUrls: ['./match-details.component.scss'],
})
export class MatchDetailsComponent implements OnInit {
  eventLocationLink: string;
  activeTab = 'home';
  isCollapsed: boolean = true;
  teamHomeTickets: any[] = [];
  teamAwayTickets: any[] = [];
  tickets: IMatchTicket[];
  teamSponsors: ITeamSponsor[] = [];
  subs: Subscription[] = [];
  ticketsAvilabilityForTeamHome: boolean;
  ticketsAvilabilityForTeamAway: boolean;
  termsList: string[] = [];
  eligible = false;
  match: IMatch;
  teams: any;
  matchId: any;
  terms: any;
  MatchStatusEnum = MatchStatusEnum;
  constructor(
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private dataService: HttpBaseService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toast: ToastService
  ) {
    this.matchId = this.route.snapshot.paramMap.get('matchId');
  }

  ngOnInit(): void {
    this.getmatcheDetails();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getTermsAndConditions();
    });
  }
  openMap(event: Event): void {
    event.preventDefault();
    const lat = this.match?.stadium?.lat;
    const lng = this.match?.stadium?.lng;

    if (lat && lng) {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lng}`;
      window.open(url, '_blank');
    } else {
      this.toast.show(
        'Error',
        this.translate.instant('Location is unavailable for this event.'),
        {
          classname: Toast.error,
        }
      );
    }
  }

  getmatcheDetails() {
    this.spinner.show();
    const params: any = {};
    this.dataService
      .get(`${matchesApi}/${this.matchId}`, { params: params })
      .subscribe((res: any) => {
        if (res) {
          this.spinner.hide();
          this.match = res;
          if (this.match.status === MatchStatusEnum.EarlySales) {
            this.checkUserEligibility();
          }
          this.getMatchTIckets();
          this.getTeamsSponsers();
          this.getTermsAndConditions();

          this.teams = [
            { id: 'home', team: this.match?.teamHome },
            { id: 'away', team: this.match?.teamAway },
          ];
        }
      });
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  getTeamsSponsers() {
    this.spinner.show();

    const homeTeamRequest = this.dataService.get(
      `${sponsersApi}/${this.match.teamHome.id}/team`
    );
    const awayTeamRequest = this.dataService.get(
      `${sponsersApi}/${this.match.teamAway.id}/team`
    );

    forkJoin([homeTeamRequest, awayTeamRequest]).subscribe(
      ([homeSponsors, awaySponsors]: [ITeamSponsor[], ITeamSponsor[]]) => {
        this.spinner.hide();
        this.teamSponsors = [...homeSponsors, ...awaySponsors];
      },
      (error) => {
        this.spinner.hide();
        console.error('Error fetching sponsors:', error);
      }
    );
  }

  getMatchTIckets() {
    this.spinner.show();
    this.dataService
      .post(`${sportticketsApi}`, { matchId: this.matchId })
      .subscribe((res: IMatchTicket[]) => {
        if (res && Array.isArray(res)) {
          this.spinner.hide();
          this.tickets = res;
          if (this.tickets) {
            const teamHomeId = this.match?.teamHome?.id;
            const teamAwayId = this.match?.teamAway?.id;
            this.teamHomeTickets = this.tickets.filter(
              (ticket) => ticket.team.id === teamHomeId
            );
            this.teamAwayTickets = this.tickets.filter(
              (ticket) => ticket.team.id === teamAwayId
            );
            this.ticketsAvilabilityForTeamHome =
              this.teamHomeTickets.length > 0;
            this.ticketsAvilabilityForTeamAway =
              this.teamAwayTickets.length > 0;
          }
        }
      });
  }

  openlink(sponsor: any): void {
    if (sponsor.url) {
      window.open(sponsor.url, '_blank');
    }
  }

  openChooseYourTeamDialog() {
    const modalRef = this.modalService.open(ChooseYourTeamDialogComponent);
    modalRef.componentInstance.match = this.match;
    modalRef.componentInstance.matchId = this.match.id;
    modalRef.componentInstance.ticketsAvilabilityForTeamHome =
      this.ticketsAvilabilityForTeamHome;
    modalRef.componentInstance.ticketsAvilabilityForTeamAway =
      this.ticketsAvilabilityForTeamAway;
    modalRef.dismissed.subscribe((res) => {
      if (res && res !== 0 && res !== 1) {
        this.router.navigate(['book/sport'], {
          queryParams: {
            matchId: this.matchId,
            teamId: res,
          },
        });
      }
    });
  }

  checkUserEligibility(): void {
    this.spinner.show();
    this.dataService
      .get(`${sportEarlySalesApi}/${this.matchId}/check-eligibility`)
      .subscribe(
        (res) => {
          this.eligible = res.eligible;
        },
        (err) => {
          this.eligible = false;
        }
      );
  }

  enableButtonBook(): boolean {
    if (this.match.status === MatchStatusEnum.SalesOpened) {
      return true;
    } else {
      if (this.match.status === MatchStatusEnum.EarlySales) {
        return this.eligible;
      }
      return false;
    }
  }

  openRegisterModal(): void {
    if (!this.helpers.checkItemFromLocalStorage(ACCESS_TOKEN)) {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,

        centered: true,
      };
      const modalRef = this.modalService.open(
        LoginPopupComponent,
        ngbModalOptions
      );

      modalRef.dismissed.subscribe((result) => {
        if (result) {
        }
      });
    } else {
      this.openChooseYourTeamDialog();
    }
  }

  getTermsAndConditions() {
    if (
      this.match?.termsAndConditionsAr &&
      this.translate.currentLang == 'ar'
    ) {
      this.terms = this.match?.termsAndConditionsAr;
    } else if (
      this.match?.termsAndConditionsEn &&
      this.translate.currentLang == 'en'
    ) {
      this.terms = this.match?.termsAndConditionsEn
        ? this.match?.termsAndConditionsEn
        : this.match?.termsAndConditionsAr;
    } else if (
      !this.match?.termsAndConditionsAr &&
      this.translate.currentLang == 'ar'
    ) {
      this.terms = this.match?.teamHome.termsAndConditionsAr;
    } else {
      this.terms = this.match?.teamHome?.termsAndConditionsEn
        ? this.match?.teamHome.termsAndConditionsEn
        : this.match?.teamHome.termsAndConditionsAr;
    }
  }
}
